import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { fetchLanguages, sortLanguages } from 'wwtc-sdk';
import Main from './components/Main.js';
import Login from './components/Login.js';
import { getManifestBoolean } from './manifestCapabilities';

function App() {
    const [state, setState] = React.useState({
        languages: [],
        status: 'loading',
    });

    React.useEffect(() => {
        fetchCompanyInfo().then((response) => {
            // Dynamically set the room name based on the pathname respecting the prefix assigned to the client
            window.room = response.data.pubnubRoom + '-' + window.location.pathname.split('/')[2];
            window.languagesPreTranslate = response.data.languagesPreTranslate;
            window.logoHeader = response.data.logoHeader;
            window.logoLogin = response.data.logoLogin;
            window.cognitoUserPoolId = response.data.cognitoUserPoolId;
            window.cognitoClientId = response.data.cognitoClientId;
            window.apiToken = response.data.apiToken;
            window.dictionaries = response.data.dictionaries;
            window.activeLanguageDetection = getManifestBoolean(
                response.data,
                'activeLanguageDetection',
            );
            window.activeWaitingRoom = getManifestBoolean(response.data, 'activeWaitingRoom');
            window.canKickParticipants = getManifestBoolean(response.data, 'canKickParticipants');
            window.enableAudit = getManifestBoolean(response.data, 'enableAudit');
            window.profanityFilterEnabled = getManifestBoolean(
                response.data,
                'profanityFilterEnabled',
            );
            window.bilingualTextColor = response.data.bilingualTextColor;

            // set palette color
            if (!!response.data.theme) {
                setPaletteColor(response.data.theme);
            }

            // custom language list
            // from dashboard general settings
            if (response.data.languages && response.data.languages.length > 0) {
                setState({
                    status: 'resolved',
                    languages: sortLanguages(response.data.languages),
                });
            } else {
                // language came already sorted
                fetchLanguages().then((languages) => {
                    setState({
                        status: 'resolved',
                        languages,
                    });
                });
            }
        });
    }, []);

    /**
     * Set color palette to css variables :root (src/index.css)
     * @param {object} theme Color palette properties
     */
    const setPaletteColor = (theme) => {
        document.documentElement.style.setProperty(
            '--main-bg-button-primary',
            theme.bgColorLoginButton,
        );
        document.documentElement.style.setProperty(
            '--main-color-button-primary',
            theme.mainButtonTextColor,
        );
        document.documentElement.style.setProperty('--header-color-text', theme.headerTextColor);
        document.documentElement.style.setProperty('--gradient-primary', theme.gradientPrimary);
        document.documentElement.style.setProperty('--gradient-secondary', theme.gradientSecondary);
        document.documentElement.style.setProperty(
            '--component-header-option',
            theme.textHeaderComponents,
        );

        if (!!theme.primaryColor) {
            document.documentElement.style.setProperty('--main-primary', theme.primaryColor);
        }

        document.documentElement.style.setProperty(
            '--home-color-text',
            theme.homeColorText || '#111',
        );

        document.documentElement.style.setProperty(
            '--bg-login-modal',
            theme.bgColorLoginModal || '#fefefe',
        );

        document.documentElement.style.setProperty('--bg-header', theme.bgHeader || '#fefefe');
    };

    const fetchCompanyInfo = async () => {
        try {
            const response = await fetch(
                'https://api.worldwidetechconnections.com/services/manifest/v1/box',
            );
            return response.json();
        } catch (e) {
            return new Error(e);
        }
    };

    if (state.status === 'loading') {
        return (
            <div className="loader-wrapper">
                <div className="text-center">
                    <h1 className="loader-title">Loading...</h1>
                </div>
            </div>
        );
    }
    return (
        <Router basename={window.location.pathname.replace(/(\/[^/]+)$/, '')}>
            <Switch>
                <Route path="/app">
                    <Main />
                </Route>
                <Route path="/">
                    <Login languages={state.languages} />
                </Route>
            </Switch>
        </Router>
    );
}
export default App;
